export enum GetAllowanceErr {
  NotEVMChain = 'NotEVMChain',
  ZeroAddress = 'ZeroAddress',
  IsFeeAsset = 'IsFeeAsset',
}
